import type { ContentKitRemoteComponents } from '@gitbook/contentkit-react';

import { ContentKitSelectOpenAPISpec } from './ContentKitSelectOpenAPISpec';

export const contentKitRemoteComponents: ContentKitRemoteComponents = {
    'select-source-openapi': ContentKitSelectOpenAPISpec,
};
